import React from "react";
import SEO from "../components/SEO";

const Registration = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-16 pt-28 px-4 sm:px-6 lg:px-8">
      <SEO title="Registration" />
      <div className="max-w-6xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1e1b4b] mb-6 tracking-tight">
            Registration
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Secure your spot at NCLC-2026. Please review the fee structure and
            payment details below before proceeding to the registration form.
          </p>
        </div>

        {/* Fee Structure Table */}
        <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-16">
          <div className="bg-[#4a90e2] px-6 py-4 border-b border-blue-500 text-center">
            <h2 className="text-xl font-bold text-white">
              Registration Fee Structure
            </h2>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr>
                  <th
                    className="bg-blue-50 text-[#1e1b4b] font-bold p-4 border-b border-r border-blue-100 text-center align-middle"
                    rowSpan="2"
                  >
                    Participant Category
                  </th>
                  <th
                    className="bg-[#4a90e2] text-white font-bold p-3 border-b border-r border-blue-400 text-center"
                    colSpan="2"
                  >
                    Early Bird
                  </th>
                  <th
                    className="bg-[#4a90e2] text-white font-bold p-3 border-b border-blue-400 text-center"
                    colSpan="2"
                  >
                    Late Registration
                  </th>
                </tr>
                <tr>
                  <th className="bg-blue-50/50 text-[#1e1b4b] font-semibold p-3 border-b border-r border-blue-100 text-center">
                    ILCS
                  </th>
                  <th className="bg-blue-50/50 text-[#1e1b4b] font-semibold p-3 border-b border-r border-blue-100 text-center">
                    Non-ILCS
                  </th>
                  <th className="bg-blue-50/50 text-[#1e1b4b] font-semibold p-3 border-b border-r border-blue-100 text-center">
                    ILCS
                  </th>
                  <th className="bg-blue-50/50 text-[#1e1b4b] font-semibold p-3 border-b border-blue-100 text-center">
                    Non-ILCS
                  </th>
                </tr>
              </thead>
              <tbody className="text-gray-700">
                <tr className="hover:bg-slate-50 transition-colors">
                  <td className="p-4 border-b border-r border-gray-100 font-medium">
                    Faculty
                  </td>
                  <td className="p-4 border-b border-r border-gray-100 text-center">
                    ₹ 5000/-
                  </td>
                  <td className="p-4 border-b border-r border-gray-100 text-center">
                    ₹ 6000/-
                  </td>
                  <td className="p-4 border-b border-r border-gray-100 text-center">
                    ₹ 5500/-
                  </td>
                  <td className="p-4 border-b border-gray-100 text-center">
                    ₹ 6500/-
                  </td>
                </tr>
                <tr className="bg-gray-50/50 hover:bg-slate-50 transition-colors">
                  <td className="p-4 border-b border-r border-gray-100 font-medium">
                    Postdocs
                  </td>
                  <td className="p-4 border-b border-r border-gray-100 text-center">
                    ₹ 4500/-
                  </td>
                  <td className="p-4 border-b border-r border-gray-100 text-center">
                    ₹ 5000/-
                  </td>
                  <td className="p-4 border-b border-r border-gray-100 text-center">
                    ₹ 5000/-
                  </td>
                  <td className="p-4 border-b border-gray-100 text-center">
                    ₹ 5500/-
                  </td>
                </tr>
                <tr className="hover:bg-slate-50 transition-colors">
                  <td className="p-4 border-b border-r border-gray-100 font-medium">
                    Ph.D. Student
                  </td>
                  <td className="p-4 border-b border-r border-gray-100 text-center">
                    ₹ 4000/-
                  </td>
                  <td className="p-4 border-b border-r border-gray-100 text-center">
                    ₹ 4500/-
                  </td>
                  <td className="p-4 border-b border-r border-gray-100 text-center">
                    ₹ 4500/-
                  </td>
                  <td className="p-4 border-b border-gray-100 text-center">
                    ₹ 5000/-
                  </td>
                </tr>
                <tr className="bg-gray-50/50 hover:bg-slate-50 transition-colors">
                  <td className="p-4 border-b border-r border-gray-100 font-medium">
                    Accompanying Person
                  </td>
                  <td
                    className="p-4 border-b border-r border-gray-100 text-center font-semibold"
                    colSpan="2"
                  >
                    ₹ 4000/-
                  </td>
                  <td
                    className="p-4 border-b border-gray-100 text-center font-semibold"
                    colSpan="2"
                  >
                    ₹ 5000/-
                  </td>
                </tr>
                <tr className="hover:bg-slate-50 transition-colors">
                  <td className="p-4 border-b border-r border-gray-100 font-medium">
                    Industry Professionals
                  </td>
                  <td
                    className="p-4 border-b border-r border-gray-100 text-center font-semibold text-indigo-700"
                    colSpan="2"
                  >
                    ₹ 12000/-
                  </td>
                  <td
                    className="p-4 border-b border-gray-100 text-center font-semibold text-indigo-700"
                    colSpan="2"
                  >
                    ₹ 15000/-
                  </td>
                </tr>
                <tr className="hover:bg-slate-50 transition-colors">
                  <td className="p-4 border-b border-r border-gray-100 font-medium">
                    International Delegate
                  </td>
                  <td
                    className="p-4 border-b border-r border-gray-100 text-center font-semibold text-indigo-700"
                    colSpan="2"
                  >
                    350 USD
                  </td>
                  <td
                    className="p-4 border-b border-gray-100 text-center font-semibold text-indigo-700"
                    colSpan="2"
                  >
                    400 USD
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <section className="py-8">
          <div className="max-w-6xl mx-auto px-4">
            <div className="text-center mb-10">
              <h2 className="text-3xl font-bold text-[#1e1b4b]">
                On-Site Registration Fees
              </h2>
              <div className="w-24 h-1 bg-indigo-600 mx-auto mt-3 rounded-full"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Professionals */}
              <div className="bg-white border border-blue-100 rounded-2xl p-6 shadow-sm hover:shadow-md transition">
                <h3 className="text-xl font-bold text-blue-700 mb-4">
                  Professionals / Researchers
                </h3>

                <div className="space-y-3">
                  <div className="flex justify-between items-center border-b pb-2">
                    <span className="text-gray-600">Indian Affiliation</span>
                    <span className="font-semibold text-gray-900">₹ 9,000</span>
                  </div>

                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">Foreign Affiliation</span>
                    <span className="font-semibold text-gray-900">USD 450</span>
                  </div>
                </div>
              </div>

              {/* Students */}
              <div className="bg-white border border-green-100 rounded-2xl p-6 shadow-sm hover:shadow-md transition">
                <h3 className="text-xl font-bold text-green-700 mb-4">
                  Students
                </h3>

                <div className="space-y-3">
                  <div className="flex justify-between items-center border-b pb-2">
                    <span className="text-gray-600">Indian Affiliation</span>
                    <span className="font-semibold text-gray-900">₹ 5,000</span>
                  </div>

                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">Foreign Affiliation</span>
                    <span className="font-semibold text-gray-900">USD 200</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Accompanying Persons */}
            <div className="mt-8 bg-amber-50 border border-amber-200 rounded-2xl p-6">
              <h3 className="text-xl font-bold text-amber-700 mb-4">
                Accompanying Persons
              </h3>

              <p className="text-gray-700 mb-5">
                Coupons can be purchased from the Registration Desk through
                on-site payment.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="bg-white rounded-xl p-4 border border-amber-100">
                  <p className="text-gray-600 text-sm">Breakfast (One Meal)</p>
                  <p className="text-2xl font-bold text-gray-900">₹ 150</p>
                </div>

                <div className="bg-white rounded-xl p-4 border border-amber-100">
                  <p className="text-gray-600 text-sm">
                    Lunch or Dinner (One Meal)
                  </p>
                  <p className="text-2xl font-bold text-gray-900">₹ 500</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Payment Details & QR Codes */}
        <div className="text-center mb-10 pt-10">
          <h2 className="text-3xl font-bold text-[#1e1b4b]">Payment Details</h2>
          <div className="w-24 h-1 bg-indigo-600 mx-auto mt-4 rounded-full"></div>
        </div>
        <div className="text-center mb-10">
          <p className="text-gray-600 text-base leading-relaxed">
            After making your payment, please complete{" "}
            <span className="text-indigo-600 font-semibold">
              Registration Form
            </span>{" "}
            below.
          </p>
        </div>
        <div className="mb-16 max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 items-start">
            {/* Bank Details Card */}
            <div className="flex-1 bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
              <h3 className="text-xl font-bold text-indigo-900 mb-6 flex items-center border-b border-gray-100 pb-4">
                <svg
                  className="w-6 h-6 mr-3 text-indigo-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                  />
                </svg>
                Bank Transfer Information
              </h3>
              <ul className="space-y-4">
                <li className="flex flex-col sm:flex-row sm:justify-between py-2 border-b border-gray-50">
                  <span className="text-gray-500 font-medium">Bank Name</span>
                  <span className="text-gray-900 font-bold text-right">
                    ICICI Bank Ltd.
                  </span>
                </li>
                <li className="flex flex-col sm:flex-row sm:justify-between py-2 border-b border-gray-50">
                  <span className="text-gray-500 font-medium">
                    Branch Address
                  </span>
                  <span className="text-gray-900 font-bold sm:text-right sm:max-w-xs">
                    Krishna Apra Royal Plaza, D-2, E(acb), Alpha-1, Greater
                    Noida, Gautam Budh Nagar, UP- 201306
                  </span>
                </li>
                <li className="flex flex-col sm:flex-row sm:justify-between py-2 border-b border-gray-50">
                  <span className="text-gray-500 font-medium">
                    Account Holder Name
                  </span>
                  <span className="text-gray-900 font-bold text-right">
                    Sharda University-Seminar
                  </span>
                </li>
                <li className="flex flex-col sm:flex-row sm:justify-between py-2 border-b border-gray-50">
                  <span className="text-gray-500 font-medium">Account No.</span>
                  <span className="text-gray-900 font-bold text-right">
                    025405005815 (CURRENT AC)
                  </span>
                </li>
                <li className="flex flex-col sm:flex-row sm:justify-between py-2 border-b border-gray-50">
                  <span className="text-gray-500 font-medium">IFSC Code</span>
                  <span className="text-gray-900 font-bold text-right">
                    ICIC0000254
                  </span>
                </li>
                <li className="flex flex-col sm:flex-row sm:justify-between py-2 border-b border-gray-50">
                  <span className="text-gray-500 font-medium">MICR Code</span>
                  <span className="text-gray-900 font-bold text-right">
                    110229037
                  </span>
                </li>
                <li className="flex flex-col sm:flex-row sm:justify-between py-2">
                  <span className="text-gray-500 font-medium">SWIFT Code</span>
                  <span className="text-gray-900 font-bold text-right">
                    ICICINBBCTS
                  </span>
                </li>
              </ul>
            </div>

            {/* QR Code Card */}
            <div className="lg:w-64 flex-shrink-0 flex flex-col items-center justify-center bg-white rounded-2xl shadow-sm border border-gray-100 p-6 gap-3">
              <p className="text-indigo-900 font-bold text-sm">Scan to Pay</p>
              <img
                src="/nclc-2026/assets/qr.webp"
                alt="qr-code"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
        <div className="text-center mb-10">
          <p className="text-gray-600 text-base leading-relaxed">
            Pay the amount using the above bank details, or you can use the QR
            code.
          </p>
        </div>

        {/* Links Section */}
        <div className="bg-[#1e1b4b] rounded-3xl p-10 text-center shadow-xl mb-10">
          <h2 className="text-2xl font-bold text-white mb-8">
            Ready to Complete Your Registration?
          </h2>

          <div className="flex flex-col md:flex-row justify-center items-center gap-6">
            <a
              href="https://forms.gle/E3wV5j47mhW5WJQn7"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full md:w-auto px-8 py-4 bg-indigo-500 hover:bg-indigo-400 text-white font-bold rounded-xl transition-colors shadow-lg flex items-center justify-center group"
            >
              Complete Registration Form
              <svg
                className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </a>

            <a
              href="https://forms.gle/Hm6jcFvM3UrgvQQp6"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full md:w-auto px-8 py-4 bg-transparent border-2 border-indigo-400 text-indigo-100 hover:bg-indigo-800 font-bold rounded-xl transition-colors flex items-center justify-center"
            >
              Abstract Submission Form
            </a>
          </div>

          <div className="mt-8 pt-6 border-t border-indigo-800/50">
            <p className="text-indigo-200 text-sm">
              Conference Website:{" "}
              <a
                href="https://www.sharda.ac.in/nclc-2026/"
                className="text-white hover:underline font-medium ml-1"
              >
                https://www.sharda.ac.in/nclc-2026/
              </a>
            </p>
          </div>
        </div>

        {/* Extra Value: Instructions */}
        {/* <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
          <h3 className="text-xl font-bold text-gray-900 mb-4">
            Registration Guidelines
          </h3>
          <ul className="list-disc list-inside space-y-2 text-gray-600">
            <li>
              Students and Postdocs must upload a valid institutional ID card
              during registration.
            </li>
            <li>
              Registration fee includes access to all scientific sessions,
              conference kit, lunches, and the gala dinner.
            </li>
            <li>
              Accommodation is not included in the registration fee and must be
              booked separately.
            </li>
            <li>
              Please ensure the transaction reference number is saved carefully,
              as it will be required in the Google Form.
            </li>
          </ul>
        </div> */}
      </div>
    </div>
  );
};

export default Registration;

